import { TPlacement } from 'types/story';

export const storyKeys = {
  all: ['story'] as const,
  groups: (placement: TPlacement) => [...storyKeys.all, 'groups', placement] as const,
  group: (id: string) => [...storyKeys.all, 'group', id] as const,
  feed: (placement: TPlacement) => [...storyKeys.all, 'feed', placement] as const,
};
